// This function wraps window.location.href (to redirect to a route outside of this app)
// and adds an alert for localhost to enable testing assertions.
export const redirectTo = (path: string, message = ''): void => {
    if (process.env.REACT_APP_ENV === 'localhost') {
        alert(`${message} Redirecting to ${path}`.trim());
        return;
    }
    window.location.href = path;
}